/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Search_LabelInputs */

const cs_ares_search_label = /** @type {(inputs: Ares_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání firmy v ARES`)
};

const en_ares_search_label = /** @type {(inputs: Ares_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARES company search`)
};

/**
* | output |
* | --- |
* | "ARES company search" |
*
* @param {Ares_Search_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_search_label = /** @type {((inputs?: Ares_Search_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Search_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_search_label(inputs)
	return cs_ares_search_label(inputs)
});